import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'shared/components/UC/Button';
import styles from './LoginPage.module.css';

const CAS_DEMO_ACCOUNTS = [
  {
    email: 'investigador@test.com',
    name: 'María González',
    description:
      'IR — draft, enviada, en evaluación, adjudicada, no seleccionada',
  },
  {
    email: 'researcher.consolidated@test.local',
    name: 'Jorge Fuentes',
    description: 'IR — sin postulaciones',
  },
  {
    email: 'researcher.other_unit@test.local',
    name: 'Carolina Rivas',
    description: 'IR — 1 postulación enviada',
  },
  {
    email: 'investigador.bloqueado@test.local',
    name: 'Luis Paredes',
    description: 'IR — habilitación pendiente (POS-003)',
  },
];

const LoginPage: React.FC = () => {
  const [isLoading] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState<
    string | null
  >(null);

  // Check for session expiration message from navigation state or sessionStorage
  useEffect(() => {
    const state = location.state as any;
    if (state?.sessionExpired) {
      setSessionExpiredMessage(
        state.message ||
          'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.'
      );
      // Clear the state to avoid showing the message on refresh
      window.history.replaceState({}, document.title);
    } else if (sessionStorage.getItem('session_expired') === 'true') {
      // Check sessionStorage for session expiration from file uploads (XHR)
      setSessionExpiredMessage(
        'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.'
      );
      sessionStorage.removeItem('session_expired');
    }
  }, [location]);

  const handleCasLogin = () => {
    setShowPicker(true);
  };

  const handleSelectAccount = (email: string) => {
    navigate(`/cas-callback?ticket=demo-ticket:${encodeURIComponent(email)}`);
  };

  const handleExternalLogin = () => {
    navigate('/admin');
  };

  return (
    <div className={styles.loginContainer}>
      <h1 className="uc-sr-only">Plataforma de postulación Avanza UC</h1>
      <div className={styles.loginColumnsContainer}>
        <div className={styles.leftColumn}>
          <div className={styles.valueProposition}>
            <div className={styles.titleContainer}>
              <h2 className={styles.valueTitle}>
                Concurso de Investigación: Avanza UC 2025
              </h2>
              <div
                className="uc-text-divider divider-secondary"
                style={{ width: '84px' }}
              ></div>
            </div>
            <div className={styles.valueContent}>
              <p>
                Como parte de sus primeras iniciativas, la Estrategia UC
                2026-2030 de la Pontificia Universidad Católica de Chile (UC) a
                través de la Dirección de Investigación (DINV) de la
                Vicerrectoría de Investigación y Postgrado (VRIP) invita a su
                cuerpo académico a postular al{' '}
                <b>Concurso de Investigación "Avanza UC 2025"</b>,
                destinado a impulsar proyectos audaces, de frontera, de alto
                riesgo e impacto, en las artes, humanidades, ciencias y
                tecnología, incluyendo desde investigaciones y creaciones
                fundamentales hasta sus formas más aplicadas, que busquen
                atender desafíos estratégicos de Chile y con potencial de
                trascender a una escala global.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.rightColumn}>
          <div className={styles.loginCardContainer}>
            <div className={styles.loginCard}>
              <div className={styles.header}>
                <div className="d-flex align-items-center">
                  <h3>Iniciar Sesión</h3>
                  <span className="uc-heading-decoration"></span>
                </div>
              </div>

              {sessionExpiredMessage && (
                <div className="uc-alert uc-alert-warning mb-3" role="alert">
                  <div className="d-flex align-items-start">
                    <i className="uc-icon me-2" style={{ fontSize: '1.25rem' }}>
                      warning
                    </i>
                    <div>
                      <strong>Sesión Expirada</strong>
                      <p className="mb-0">{sessionExpiredMessage}</p>
                    </div>
                  </div>
                </div>
              )}

              {!showPicker ? (
                <Button
                  type="button"
                  variant="cta"
                  onClick={handleCasLogin}
                  disabled={isLoading}
                  style={{
                    width: '100%',
                    justifyContent: 'center',
                  }}
                >
                  Iniciar Sesión con UC CAS
                </Button>
              ) : (
                <div className={styles.userPicker}>
                  <p className={styles.userPickerTitle}>
                    Selecciona una cuenta demo
                  </p>
                  {CAS_DEMO_ACCOUNTS.map((account) => (
                    <button
                      key={account.email}
                      className={styles.userPickerItem}
                      onClick={() => handleSelectAccount(account.email)}
                      type="button"
                    >
                      <span className={styles.userPickerName}>
                        {account.name}
                      </span>
                      <span className={styles.userPickerDesc}>
                        {account.description}
                      </span>
                    </button>
                  ))}
                  <button
                    className={styles.userPickerCancel}
                    onClick={() => setShowPicker(false)}
                    type="button"
                  >
                    Cancelar
                  </button>
                </div>
              )}

              <div className={styles.divider}>
                <span className={styles.dividerText}></span>
              </div>

              <Button
                type="button"
                variant="secondary"
                onClick={handleExternalLogin}
                disabled={isLoading}
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  lineHeight: '1',
                }}
              >
                Ingresar como Evaluador
              </Button>
            </div>
            {/* <div className={styles.footer}>
              <p className={styles.footerText}>
                ¿Necesitas ayuda? Consulta acá <i className="uc-icon icon-size--sm" style={{color: 'var(--color-primary-dark)'}}>arrow_downward</i>
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
